module.exports = __webpack_public_path__ + "static/media/order-vintage-design-items-online-at-our-website-and-buy-secure-from-zo-goed-als-oud.75e99aa0.jpg";